// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__f7f_b","accordionWrapper":"Accordion_accordionWrapper__LQa9w"};